import { IHexGridData } from 'js/bubbleCore/types';
import { hashToColRow } from 'js/bubbleCore/utils/hash';

export function loopGrid<T>(grid: IHexGridData<T>, callback: (value: T, col: number, row: number) => void): void {
  Object.entries(grid.values).forEach(([hash, bubble]) => {
    callback(bubble, ...hashToColRow(hash));
  });
}